import React from "react";

const TeethWhitening = () => {
  return (
    <div>
      <h1>TeethWhitening</h1>
      <p>Details about general dentistry services...</p>
    </div>
  );
};

export default TeethWhitening;
